import React, { useEffect, useState } from 'react';
import { Clock, Calendar, Phone } from 'lucide-react';
import api from '../lib/api';

const DEFAULT_HOURS = {
  days: [
    { label: 'Lunedì', hours: '09:00 – 13:00 / 14:00 – 18:00' },
    { label: 'Martedì', hours: '09:00 – 13:00 / 14:00 – 18:00' },
    { label: 'Mercoledì', hours: '09:00 – 13:00 / 14:00 – 18:00' },
    { label: 'Giovedì', hours: '09:00 – 13:00 / 14:00 – 18:00' },
    { label: 'Venerdì', hours: '09:00 – 13:00 / 14:00 – 17:00' },
    { label: 'Sabato', hours: 'Su appuntamento' },
    { label: 'Domenica', hours: 'Su appuntamento' },
  ],
  on_call_phone: '+39 339 2020405',
  on_call_note: 'Per produzioni in corso è attiva la reperibilità telefonica.',
  delivery_note: 'Servizio di consegna e ritiro disponibile su richiesta in tutta Italia.',
};

const Orario = () => {
  const [data, setData] = useState(DEFAULT_HOURS);

  useEffect(() => {
    api.get('/opening-hours')
      .then((r) => setData(r.data))
      .catch(() => setData(DEFAULT_HOURS));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 lg:px-6 py-10 fade-in" data-testid="orario-page">
      <div className="flex items-center gap-3 mb-2">
        <Clock className="text-[#d62828]" size={28} />
        <h1 className="text-4xl font-black brand-text text-neutral-900">Orario di Apertura</h1>
      </div>
      <p className="text-neutral-600">Orari del nostro magazzino di Barberino Tavarnelle / Poggibonsi.</p>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <div className="p-6 bg-white border border-neutral-200 rounded-lg">
          <h3 className="font-bold text-neutral-800 mb-4 flex items-center gap-2"><Calendar size={18} className="text-[#d62828]" /> Settimana</h3>
          <ul className="space-y-2 text-sm">
            {(data.days || []).map((d, i) => (
              <li key={d.label || i} className="flex justify-between border-b border-neutral-100 pb-2" data-testid={`orario-day-${i}`}>
                <span className="font-medium text-neutral-700">{d.label}</span>
                <span className="text-neutral-600">{d.hours}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="p-6 bg-[#d62828]/5 border border-[#d62828]/20 rounded-lg">
          <h3 className="font-bold text-neutral-800 mb-4 flex items-center gap-2"><Phone size={18} className="text-[#d62828]" /> Reperibilità produzioni</h3>
          {data.on_call_note && (
            <p className="text-neutral-700 text-sm" data-testid="orario-oncall-note">
              {data.on_call_note}
              {data.on_call_phone && <> Numero: <strong>{data.on_call_phone}</strong>.</>}
            </p>
          )}
          {data.delivery_note && (
            <p className="text-neutral-600 text-sm mt-3" data-testid="orario-delivery-note">
              {data.delivery_note}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Orario;
